/** Best-effort filename from Content-Disposition (RFC 5987 / quoted). */
export function parseContentDispositionFilename(header: string | null): string | undefined {
  if (!header) {
    return undefined;
  }
  const star = /filename\*=(?:UTF-8''|)([^;\s]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].replace(/"/g, '').trim());
    } catch {
      return star[1].replace(/"/g, '').trim();
    }
  }
  const plain = /filename="([^"]+)"/i.exec(header) ?? /filename=([^;\s]+)/i.exec(header);
  return plain?.[1]?.replace(/"/g, '').trim();
}

export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}

/** Short text for toast when a PDF request fails (body is consumed). */
export async function readPdfExportErrorDetail(response: Response): Promise<string> {
  try {
    const text = (await response.text()).trim();
    if (!text) {
      return '';
    }
    try {
      const j = JSON.parse(text) as { message?: string; title?: string; errors?: unknown };
      const msg = j.message ?? j.title;
      if (typeof msg === 'string' && msg.trim()) {
        return msg.trim();
      }
    } catch {
      /* not JSON */
    }
    return text.length > 180 ? `${text.slice(0, 180)}…` : text;
  } catch {
    return '';
  }
}
